import React from 'react'
import {IconButton, Tooltip} from '@mui/material'
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded'
import {useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

const NavigateIconButton = ({
    to,
    titleKey,
    title,
    icon: IconComponent = CalendarMonthRoundedIcon,
    size = 'medium',
}) => {
    const navigate = useNavigate()
    const {t} = useTranslation()
    const tooltipLabel = title ?? (titleKey ? t(titleKey) : '')

    const handleClick = React.useCallback(() => {
        if (to) {
            navigate(to)
        }
    }, [navigate, to])

    return (
        <Tooltip title={tooltipLabel}>
            <IconButton onClick={handleClick} aria-label={tooltipLabel} size={size}>
                <IconComponent fontSize="inherit" />
            </IconButton>
        </Tooltip>
    )
}

export default NavigateIconButton
